var {
  useSearchFieldState
} = require("@react-stately/searchfield");

var {
  useSearchField
} = require("@react-aria/searchfield");

var {
  useProviderProps
} = require("@react-spectrum/provider");

var {
  TextFieldBase
} = require("@react-spectrum/textfield");

var _react2 = require("react");

var _react = $parcel$interopDefault(_react2);

var {
  forwardRef,
  useRef
} = _react2;

var _spectrumIconsUiMagnifier = $parcel$interopDefault(require("@spectrum-icons/ui/Magnifier"));

var {
  ClearButton
} = require("@react-spectrum/button");

var {
  classNames,
  useSlotProps
} = require("@react-spectrum/utils");

var _babelRuntimeHelpersObjectWithoutPropertiesLoose = $parcel$interopDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/search/vars.css
var $b42ee6503342f63a10b70c33e73302b1$exports = {};
$b42ee6503342f63a10b70c33e73302b1$exports = {
  "spectrum-Search": "_spectrum-Search_d08c7",
  "spectrum-ClearButton": "_spectrum-ClearButton_d08c7",
  "is-quiet": "_is-quiet_d08c7",
  "spectrum-Search-input": "_spectrum-Search-input_d08c7",
  "spectrum-Search--invalid": "_spectrum-Search--invalid_d08c7",
  "spectrum-Search--valid": "_spectrum-Search--valid_d08c7",
  "spectrum-Search--loadable": "_spectrum-Search--loadable_d08c7",
  "spectrum-Search-circleLoader": "_spectrum-Search-circleLoader_d08c7",
  "spectrum-Search-validationIcon": "_spectrum-Search-validationIcon_d08c7",
  "spectrum-Textfield": "_spectrum-Textfield_d08c7"
};
var $b42ee6503342f63a10b70c33e73302b1$$interop$default = $parcel$interopDefault($b42ee6503342f63a10b70c33e73302b1$exports);

function $c7bd01575afa7bea7ba1694646$var$SearchField(props, ref) {
  props = useSlotProps(props, 'searchfield');
  props = useProviderProps(props);

  let defaultIcon = /*#__PURE__*/_react.createElement(_spectrumIconsUiMagnifier, null);

  let {
    icon = defaultIcon,
    isDisabled,
    UNSAFE_className
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["icon", "isDisabled", "UNSAFE_className"]);

  let state = useSearchFieldState(props);
  let inputRef = useRef();
  let {
    labelProps,
    inputProps,
    clearButtonProps,
    descriptionProps,
    errorMessageProps
  } = useSearchField(props, state, inputRef);

  let clearButton = /*#__PURE__*/_react.createElement(ClearButton, _babelRuntimeHelpersExtends({}, clearButtonProps, {
    preventFocus: true,
    UNSAFE_className: classNames($b42ee6503342f63a10b70c33e73302b1$$interop$default, 'spectrum-ClearButton'),
    isDisabled: isDisabled
  }));

  return /*#__PURE__*/_react.createElement(TextFieldBase, _babelRuntimeHelpersExtends({}, otherProps, {
    labelProps: labelProps,
    inputProps: inputProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    UNSAFE_className: classNames($b42ee6503342f63a10b70c33e73302b1$$interop$default, 'spectrum-Search', 'spectrum-Textfield', {
      'is-disabled': isDisabled,
      'is-quiet': props.isQuiet,
      'spectrum-Search--invalid': props.validationState === 'invalid',
      'spectrum-Search--valid': props.validationState === 'valid'
    }, UNSAFE_className),
    inputClassName: classNames($b42ee6503342f63a10b70c33e73302b1$$interop$default, 'spectrum-Search-input'),
    ref: ref,
    inputRef: inputRef,
    isDisabled: isDisabled,
    icon: icon,
    wrapperChildren: state.value !== '' && !props.isReadOnly && clearButton
  }));
}
/**
 * A SearchField is a text field designed for searches.
 */


let SearchField = /*#__PURE__*/forwardRef($c7bd01575afa7bea7ba1694646$var$SearchField);
exports.SearchField = SearchField;
